import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-container">
      {/* Content */}
      <main className="privacy-content">
        <section className="privacy-section">
          <h2 className="section-title">Privacy Policy</h2>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">1. Information We Collect</h2>
          <p className="text">
            We collect information you provide directly to us, such as when you create an account, 
            make a purchase, use AI features, or contact us for support. This may include:
          </p>
          <ul className="bullet-list">
            <li>Personal information (name, email, phone number)</li>
            <li>Payment information</li>
            <li>Profile pictures and preferences</li>
            <li>Body measurements and size preferences</li>
            <li>Communication history</li>
            <li>AI-generated content and face swap images</li>
            <li>User-generated content and product reviews</li>
            <li>Device information and usage analytics</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">2. How We Use Your Information</h2>
          <p className="text">
            We use the information we collect to:
          </p>
          <ul className="bullet-list">
            <li>Provide and maintain our services</li>
            <li>Process transactions and send confirmations</li>
            <li>Personalize your experience</li>
            <li>Send you updates and marketing communications</li>
            <li>Respond to your comments and questions</li>
            <li>Improve our services</li>
            <li>Process AI face swap requests and generate personalized content</li>
            <li>Moderate user-generated content and prevent misuse</li>
            <li>Ensure compliance with our terms and applicable laws</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">3. Information Sharing</h2>
          <p className="text">
            We do not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except in the following circumstances:
          </p>
          <ul className="bullet-list">
            <li>With service providers who assist in our operations</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and safety</li>
            <li>In connection with a business transfer</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">4. AI and Face Swap Features</h2>
          <p className="text">
            Our app includes AI-powered face swap technology that allows you to visualize products 
            on your face. When using these features:
          </p>
          <ul className="bullet-list">
            <li>You must only use your own face or faces you have explicit permission to use</li>
            <li>You are responsible for obtaining consent from individuals whose faces you use</li>
            <li>We may store face swap images temporarily to provide the service</li>
            <li>AI-generated content is for personal use only and may not be shared without permission</li>
            <li>We reserve the right to remove content that violates our policies</li>
            <li>Face swap images are processed securely and deleted after use</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">5. User-Generated Content</h2>
          <p className="text">
            When you upload content, including face swap images and reviews:
          </p>
          <ul className="bullet-list">
            <li>You retain ownership of your original content</li>
            <li>You grant us license to use, modify, and display your content</li>
            <li>You must not upload content that infringes on others' rights</li>
            <li>We may moderate and remove inappropriate content</li>
            <li>You are responsible for the accuracy and legality of your content</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">6. Data Security</h2>
          <p className="text">
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. However, no method of 
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">7. Your Rights</h2>
          <p className="text">
            You have the right to:
          </p>
          <ul className="bullet-list">
            <li>Access your personal information</li>
            <li>Update or correct your information</li>
            <li>Delete your account</li>
            <li>Opt out of marketing communications</li>
            <li>Request data portability</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">8. Cookies and Tracking</h2>
          <p className="text">
            We use cookies and similar tracking technologies to enhance your experience, 
            analyze usage patterns, and provide personalized content.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">9. Children's Privacy</h2>
          <p className="text">
            Our services are not intended for children under 13. We do not knowingly collect 
            personal information from children under 13.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">10. Changes to This Policy</h2>
          <p className="text">
            We may update this privacy policy from time to time. We will notify you of any 
            changes by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="section-title">11. Contact Us</h2>
          <p className="text">
            If you have any questions about this privacy policy, please contact us at:
          </p>
          <p className="contact-info">Email: privacy@only2u.com</p>
          <p className="contact-info">Phone: +91 98111 50757</p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
